import React, { useContext } from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import ArrowrightIcon from 'icons/Arrowright.icon';
import useNdaStatus from 'hooks/useNdaStatus';
import { Lead } from 'models/Lead';
import { isNdaSent } from 'utils';
import TransWithNda from 'components/TransWithNda';
import { SHORT_MAX_CHARS } from 'components/TransWithNda/TransWithNda.component';
import { getHasNdaToSend } from 'agreementUtils';
import ListingContext from '../../../../providers/Listing/Listing.context';

import './ResendNda.styles.scss';

type ResendNdaProps = {
  className?: string;
  lead: Lead;
};

const ResendNda: React.FC<ResendNdaProps> = (props) => {
  const { className, lead } = props;

  const classes = classNames('resend-nda', className);

  const { listing } = useContext(ListingContext);

  const {
    _id: leadId,
    envelopeTemplateId,
    envelopeId,
    signingStatus,
    envelopeTemplateName,
    ndaProvider,
    agreementExecutionId,
    agreementExecuted,
  } = lead;

  const { isLoading, resendNda } = useNdaStatus(
    leadId,
    envelopeId,
    undefined,
    { ndaProvider, agreementExecutionId, agreementExecuted },
  );

  if (
    !getHasNdaToSend(envelopeTemplateId, listing) ||
    !isNdaSent(signingStatus)
  )
    return null;

  return (
    <Button
      className={classes}
      variant="outline"
      iconPosition="right"
      disabled={isLoading}
      icon={ArrowrightIcon}
      onClick={() => resendNda()}
    >
      <TransWithNda
        i18nKey="resendNDA"
        maxChars={SHORT_MAX_CHARS}
        envelopeTemplateName={envelopeTemplateName}
      />
    </Button>
  );
};

export default ResendNda;
